<template>
  <div class="plan_item">
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <img src="https://www.7859888tp.com/750-50.gif" />
    </div>
    <div class="plan_item_title">澳门妈祖阁 五肖二期必中</div>
    <ul>
      <li v-for="(el, i) in data.list" :key="i" :class="{ li_win: el.ifWin }">
        <div class="qi">
          <p v-for="qi in el.qiShu" :key="qi">{{ qi }}期</p>
        </div>
        <div class="value">
          <span
            v-for="i in el.yuCe"
            :class="{ win: el.shengXiao.includes(i) }"
            >{{ i }}</span
          >
        </div>
        <div class="kaijiang">
          <p v-for="(code, codeIndex) in el.code" :key="codeIndex">
            开：{{ code }}{{ el.shengXiao[codeIndex] }}
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>
    
    <script setup>
import top from "@/assets/img/top.gif";
import { toRefs } from "vue";

const props = defineProps({
  data: Object,
});

const { data } = toRefs(props);

data.value.list = data.value.list.reverse();
</script>
    
    <style lang="scss" scoped>
.title {
  text-align: center;
  background-color: #009788;
  font-size: 25px;
  font-weight: bold;
  padding: 6px 0;
}
.plan_item {
  border: 1px solid #009788;
  .plan_item_advertisement {
    img {
      width: 100%;
      height: 40px;
      display: block;
    }
  }
  .plan_item_title {
    font-weight: bold;
    text-align: center;
    background-image: linear-gradient(to bottom, #b4b9b1, #f1edeb);
    padding: 3px 0;
    border-top: 2px solid #767474;
    border-bottom: 2px solid #767474;
    img {
      width: 30px;
      height: 30px;
    }
  }
  ul {
    background-color: #eee;
    li {
      text-align: center;
      //   padding: 5px 12px;
      padding: 0 !important;
      font-weight: bold;
      display: flex;
      justify-content: center;
      .qi {
        grid-gap: 6px;
        color: #000;
        padding: 3px 12px;
        border-right: 1px solid #ccc;
      }
      .value {
        color: red;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 120%;
        .win {
          background: #fbfb00;
        }
      }
      .kaijiang {
        padding: 0 12px;
        border-left: 1px solid #ccc;
      }
      &:not(:last-child) {
        border-bottom: 2px solid #d2d2d2;
      }
    }
    .li_win {
      .winText {
        color: #d00880;
      }
    }
    .suck {
      text-decoration-line: line-through;
    }
  }
}
</style>